import { KeepAlive } from "vue";

export default [
  {
    path: "/factory",
    name: "factory",
    meta: {
      title: "t_qylb",
      scroll: true,
      permission: "",
    },
    component: () => import("../../views/layout.vue"),
    redirect: "/factory/index",
    children: [
      {
        path: "/factory/index",
        name: "factoryHome",
        meta: {
          title: "t_qylb",
          scroll: true,
          permission: "home:SWIndex",
        },
        component: () => import("../../views/factory/home.vue"),
      },
      {
        path: "/factory/monitor",
        name: "factoryMonitor",
        meta: {
          title: "t_kr92",
          scroll: true,
          permission: "",
        },
        component: () => import("../../views/factory/monitor.vue"),
      },
      {
        path: "/factory/waste",
        name: "factoryWaste",
        meta: {
          title: "t_bddzje",
          scroll: true,
          permission: "waste",
        },
        component: () => import("../../views/factory/waste/index.vue"),
        redirect: "/factory/waste/feeding",
        children: [
          {
            path: "/factory/waste/feeding",
            name: "factoryWasteFeeding",
            meta: {
              title: "t_cv6g5l",
              scroll: true,
              permission: "waste:deliveryDetail",
              keepAlive: true
            },
            component: () => import("../../views/factory/waste/feeding.vue"),
          },
          {
            path: "/factory/waste/feedingDetail",
            name: "factoryWasteFeedingDetail",
            meta: {
              title: "t_cv6hqb",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/feedingDetail.vue"),
          },
          {
            path: "/factory/waste/storage",
            name: "factoryWasteStorage",
            meta: {
              title: "t_fgikf",
              scroll: true,
              permission: "waste:storageDetail",
              keepAlive: true
            },
            component: () => import("../../views/factory/waste/storage.vue"),
          },
          {
            path: "/factory/waste/storageDetail",
            name: "factoryWasteStorageDetail",
            meta: {
              title: "t_cd7115",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/storageDetail.vue"),
          },
          {
            path: "/factory/waste/storageSuccess",
            name: "factoryWasteStorageSuccess",
            meta: {
              title: "t_d1spvi",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/storageSuccess.vue"),
          },
          {
            path: "/factory/waste/orderIn",
            name: "factoryWasteOrderIn",
            meta: {
              title: "t_cdqh3",
              scroll: true,
              permission: "waste:orderIn",
              keepAlive: true
            },
            component: () => import("../../views/factory/waste/orderIn.vue"),
          },
          {
            path: "/factory/waste/orderInDetail",
            name: "factoryWasteOrderInDetail",
            meta: {
              title: "t_ao3y7h",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/orderInDetail.vue"),
          },
          {
            path: "/factory/waste/orderOut",
            name: "factoryWasteOrderOut",
            meta: {
              title: "t_cgsyk",
              scroll: true,
              permission: "waste:orderOut",
              keepAlive: true
            },
            component: () => import("../../views/factory/waste/orderOut.vue"),
          },
          {
            path: "/factory/waste/orderOutDetail",
            name: "factoryWasteOrderOutDetail",
            meta: {
              title: "t_aqr394",
              scroll: true,
              permission: ""
            },
            component: () =>
              import("../../views/factory/waste/orderOutDetail.vue"),
          },
          // {
          //   path: '/factory/waste/workOrder',
          //   name: 'factoryWasteWorkOrder',
          //   meta:{
          //     title: '工单',
          //     scroll: true,
          //     permission: 'waste:mapNumMaterial'
          //   },
          //   component: () => import("../../views/factory/waste/workOrder.vue"),
          // },
          {
            path: "/factory/waste/workOrderDetail",
            name: "factoryWasteWorkOrderDetail",
            meta: {
              title: "t_c77y5r",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/workOrderDetail.vue"),
          },
          {
            path: "/factory/waste/bration",
            name: "factoryWasteBration",
            meta: {
              title: "t_acd50l",
              scroll: true,
              permission: "",
              keepAlive: true
            },
            component: () => import("../../views/factory/waste/bration.vue"),
          },
          {
            path: "/factory/waste/brationDetail",
            name: "factoryWasteBrationDetail",
            meta: {
              title: "t_48cg70",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/brationDetail.vue"),
          },
          {
            path: "/factory/waste/deliveryCode",
            name: "factoryWasteDeliveryCode",
            meta: {
              title: "t_exrdp",
              scroll: true,
              permission: "waste:deliveryCode",
            },
            component: () =>
              import("../../views/factory/waste/deliveryCode.vue"),
          },
          {
            path: "/factory/waste/destroyProve",
            name: "factoryWasteDestroyProve",
            meta: {
              title: "t_j90e7i",
              scroll: true,
              permission: "waste:destroyProve",
              keepAlive: true
            },
            component: () =>
              import("../../views/factory/waste/destroyProve.vue"),
          },
          {
            path: "/factory/waste/destroyProveDetail",
            name: "factoryWasteDestroyProveDetail",
            meta: {
              title: "t_vixcel",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/destroyProveDetail.vue"),
          },
          {
            path: "/factory/waste/project",
            name: "factoryWasteProject",
            meta: {
              title: "t_abq7ot",
              scroll: true,
              keepAlive: true,
              permission: "waste:deliveryExtend",
            },
            component: () => import("../../views/factory/waste/project.vue"),
          },
          {
            path: "/factory/waste/projectDetail",
            name: "factoryWasteProjectDetail",
            meta: {
              title: "t_l8c3lg",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/projectDetail.vue"),
          },
          {
            path: "/factory/waste/verifyDetail",
            name: "factoryWasteVerifyDetail",
            meta: {
              title: "t_l57cuk",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/waste/verifyDetail.vue"),
          },
          {
            path: "/factory/waste/workDetail",
            name: "factoryWasteWorkDetail",
            meta: {
              title: "t_f2qpgz",
              scroll: true,
              permission: "",
            },
            component: () => import("../../views/factory/waste/workDetail.vue"),
          },
        ],
      },
      {
        path: "/factory/settle",
        name: "factorySettle",
        meta: {
          title: "t_gl4wvs",
          scroll: true,
          permission: "settle",
        },
        component: () => import("../../views/factory/settle/index.vue"),
        redirect: "/factory/settle/wait",
        children: [
          {
            path: "/factory/settle/wait",
            name: "factorySettleWait",
            meta: {
              title: "t_em0oo",
              scroll: true,
              permission: "settle:wait",
            },
            component: () => import("../../views/factory/settle/wait.vue"),
          },
          {
            path: "/factory/settle/complete",
            name: "factorySettleComplete",
            meta: {
              title: "t_j97gi",
              scroll: true,
              permission: "settle:complete",
              keepAlive: true
            },
            component: () => import("../../views/factory/settle/complete.vue"),
          },
          {
            path: "/factory/settle/completeDetail",
            name: "factorySettleCompleteDetail",
            meta: {
              title: "t_gto1ep",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/settle/completeDetail.vue"),
          },
          {
            path: "/factory/settle/settleSuccess",
            name: "factorySettleSettleSuccess",
            meta: {
              title: "t_d1spvi",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/settle/settleSuccess.vue"),
          },
          {
            path: "/factory/settle/collectDetail",
            name: "factorySettleCollectDetail",
            meta: {
              title: "t_ajc2ac",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/settle/collectDetail.vue"),
          },
        ],
      },
      {
        path: "/factory/analysis",
        name: "factoryAnalysis",
        meta: {
          title: "t_d7k0js",
          scroll: true,
          permission: "waste:summary",
        },
        component: () => import("../../views/factory/analysis/index.vue"),
        redirect: "/factory/analysis/output",
        children: [
          {
            path: "/factory/analysis/dataAnalysis",
            name: "factoryAnalysisDataAnalysis",
            meta: {
              title: "t_abe59e",
              scroll: true,
              permission: "waste:summary:produce",
            },
            component: () =>
              import("../../views/factory/analysis/dataAnalysis.vue"),
          },
          {
            path: "/factory/analysis/output",
            name: "factoryAnalysisOutput",
            meta: {
              title: "t_gd98ey",
              scroll: true,
              permission: "waste:summary:output",
            },
            component: () => import("../../views/factory/analysis/output.vue"),
          },
          {
            path: "/factory/analysis/stockStat",
            name: "factoryAnalysisStockStat",
            meta: {
              title: "t_cbfbev",
              scroll: true,
              permission: "waste:summary:stockStat",
            },
            component: () =>
              import("../../views/factory/analysis/stockStat.vue"),
          },
          {
            path: "/factory/analysis/auditStat",
            name: "factoryAnalysisAuditStat",
            meta: {
              title: "t_abfz7c",
              scroll: true,
              permission: "waste:summary:auditStat",
            },
            component: () =>
              import("../../views/factory/analysis/auditStat.vue"),
          },
          {
            path: "/factory/analysis/dashboard",
            name: "factoryAnalysisDashboard",
            meta: {
              title: "t_d7l48s",
              scroll: true,
              permission: "waste:summary:dashboard",
            },
            component: () =>
              import("../../views/factory/analysis/dashboard.vue"),
          },
        ],
      },
      {
        path: "/factory/ledger",
        name: "factoryLedger",
        meta: {
          title: "t_exe2mc",
          scroll: true,
          permission: "ledger",
        },
        component: () => import("../../views/factory/ledger/index.vue"),
        redirect: "/factory/ledger/produceList",
        children: [
          {
            path: "/factory/ledger/produceList",
            name: "factoryLedgerProduceList",
            meta: {
              title: "t_6heg3y",
              scroll: true,
              permission: "ledger:produceList",
            },
            component: () =>
              import("../../views/factory/ledger/produceList.vue"),
          },
          {
            path: "/factory/ledger/produceList-value",
            name: "factoryLedgerProduceListValue",
            meta: {
              title: "t_k7x4b5",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/ledger/produceList-value.vue"),
          },
          {
            path: "/factory/ledger/flowDirection",
            name: "/factoryLedgerFlowDirection",
            meta: {
              title: "t_tp4z2m",
              scroll: true,
              permission: "ledger:flowDirection",
            },
            component: () =>
              import("../../views/factory/ledger/flowDirection.vue"),
          },
          {
            path: "/factory/ledger/flowDirection-value",
            name: "factoryLedgerFlowDirectionValue",
            meta: {
              title: "t_ecthlf",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/ledger/flowDirection-value.vue"),
          },
          {
            path: "/factory/ledger/factoryLink",
            name: "factoryLedgerFactoryLink",
            meta: {
              title: "t_kw9cdf",
              scroll: true,
              permission: "ledger:factoryLink",
            },
            component: () =>
              import("../../views/factory/ledger/factoryLink.vue"),
          },
          {
            path: "/factory/ledger/factoryLink-value",
            name: "factoryLedgerFactoryLinkValue",
            meta: {
              title: "t_kw9cdfDetail",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/ledger/factoryLink-value.vue"),
          },
          {
            path: "/factory/ledger/produceLink",
            name: "factoryLedgerProduceLink",
            meta: {
              title: "t_c4yxjn",
              scroll: true,
              permission: "ledger:produceLink",
            },
            component: () =>
              import("../../views/factory/ledger/produceLink.vue"),
          },
          {
            path: "/factory/ledger/produceLink-value",
            name: "factoryLedgerProduceLinkValue",
            meta: {
              title: "t_fmot2q",
              scroll: true,
              permission: "",
            },
            component: () =>
              import("../../views/factory/ledger/produceLink-value.vue"),
          },
        ],
      },
      {
        path: "/factory/setting",
        name: "factorySetting",
        meta: {
          title: "t_gar1ro",
          scroll: true,
          permission: "setting",
        },
        component: () => import("../../views/factory/setting/index.vue"),
        redirect: "/factory/setting/device",
        children: [
          {
            path: "/factory/setting/user",
            name: "factorySettingUser",
            meta: {
              title: "t_f6y6dw",
              scroll: true,
              permission: "setting:sysUser",
            },
            component: () => import("../../views/factory/setting/user.vue"),
          },
          {
            path: "/factory/setting/psa",
            name: "factorySettingPsa",
            meta: {
              title: "t_ybmfxk",
              scroll: true,
              permission: "setting:psaMap",
            },
            component: () => import("../../views/factory/setting/psa.vue"),
          },
          {
            path: "/factory/setting/linked",
            name: "factorySettingLinked",
            meta: {
              title: "t_rkezlu",
              scroll: true,
              permission: "setting:psaCardMap",
            },
            component: () => import("../../views/factory/setting/linked.vue"),
          },
          {
            path: "/factory/setting/material",
            name: "factorySettingMaterial",
            meta: {
              title: "t_dgdz62",
              scroll: true,
              permission: "setting:mapMaterialWaste",
            },
            component: () => import("../../views/factory/setting/material.vue"),
          },
        ],
      },
    ],
  },
];
